import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Bootstrapper from './Bootstrapper';

// Disable console logs in production
if (process.env.NODE_ENV === 'production') {
    console.log = () => { }
    console.error = () => { }
    console.debug = () => { }
}

function App() {
  return (
    <Router>
      <Switch>
        {/* All other routes handled by Bootstrapper */}
        <Route path="*" component={Bootstrapper} />
      </Switch>
    </Router>
  );
}

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();